import { useState } from 'react'

import { AddButton } from '#app/routes/mocra+/_form+/components/add-button.tsx'

import { DistributionSystemOverlay } from '#app/routes/mocra+/_form+/components/distribution-systems/overlay.tsx'
import {
	createDistributionSystemDraft,
	type DistributionSystemDraft,
} from '#app/routes/mocra+/_form+/components/distribution-systems/types.ts'

type Props = {
	readonly onSubmit: (draft: DistributionSystemDraft) => void
	readonly defaultValue?: DistributionSystemDraft
	readonly triggerLabel?: string
	readonly disabled?: boolean
	readonly className?: string
}

export function DistributionSystemAdd({
	onSubmit,
	defaultValue,
	triggerLabel,
	disabled,
	className,
}: Props) {
	const [open, setOpen] = useState(false)

	const handleSubmit = (draft: DistributionSystemDraft) => {
		onSubmit(draft)
		setOpen(false)
	}

	return (
		<>
			<AddButton
				onClick={() => setOpen(true)}
				disabled={disabled}
				className={className}
			>
				{triggerLabel ?? 'Add system'}
			</AddButton>
			<DistributionSystemOverlay
				mode="add"
				open={open}
				onOpenChange={setOpen}
				onSubmit={handleSubmit}
				initialValue={defaultValue ?? createDistributionSystemDraft()}
				onClosed={() => setOpen(false)}
			/>
		</>
	)
}
